import ParticipantsModal from "./participantsModal";
export default ParticipantsModal;